import { Box, useMediaQuery } from "@mui/material";
import DatePicker from "react-datepicker";
// import ru from "date-fns/locale/ru";
import { useController } from "react-hook-form";
import { FC, useEffect, useRef } from "react";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";

export const getFormattedDate = (date: Date) => {
  const year = date.getFullYear().toString().slice(-2); // Последние две цифры года
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Месяц с ведущим нулем, так как индексы месяцев начинаются с 0
  const day = date.getDate().toString().padStart(2, "0"); // День с ведущим нулем
  const hours = date.getHours().toString().padStart(2, "0"); // Часы с ведущим нулем
  const minutes = date.getMinutes().toString().padStart(2, "0"); // Минуты с ведущим нулем

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

interface DatePickerComponentProps {
  name: string;
  isEditing: boolean;
  disabled: boolean;
}

export const DatePickerComponent: FC<DatePickerComponentProps> = ({
  name,
  isEditing,
  disabled,
}) => {
  const { t } = useTranslation();
  const {
    field: { onChange, value },
  } = useController({
    name,
  });

  const pickerRef = useRef(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // prevent keyboard
  useEffect(() => {
    if (isMobile && pickerRef.current !== null) {
      //@ts-ignore
      pickerRef.current.input.readOnly = true;
    }
  }, [isMobile, pickerRef]);

  return (
    <Box sx={{ mt: "12px", width: "100%" }}>
      {/* <InputLabel>Время</InputLabel> */}
      {isEditing ? (
        <DatePicker
          ref={pickerRef}
          //   locale={ru}
          showTimeSelect
          selected={value}
          onChange={onChange}
          dateFormat="dd.MM.yy HH:mm"
          //   timeCaption={"Время"}
          minDate={new Date()}
          placeholderText={t("expire")}
          disabled={disabled}
          onFocus={(e) => e.currentTarget.blur()}
          popperPlacement="top"
        />
      ) : (
        <Box
          sx={{
            width: "132px",
            height: "55px",
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {getFormattedDate(value)}
        </Box>
      )}
    </Box>
  );
};
